const state = {
  fileUploadDisplay: false,
  waitUploading: null,
  completeFile: null,
  resumableInfo: null
}

const getters = {
  fileUploadDisplay: state => state.fileUploadDisplay,
  waitUploading: state => state.waitUploading,
  completeFile: state => state.completeFile,
  resumableInfo: state => state.resumableInfo
}

const types = {
  setFileUploadDisplay: 'gcs/setFileUploadDisplay',
  setWaitUploading: 'gcs/setWaitUploading',
  setCompleteFile: 'gcs/setCompleteFile',
  setResumableInfo: 'gcs/setResumableInfo'
}

const mutations = {
  [types.setFileUploadDisplay] (state, boolean) {
    state.fileUploadDisplay = boolean
  },
  [types.setWaitUploading] (state, data) {
    state.waitUploading = data
  },
  [types.setCompleteFile] (state, object) {
    state.completeFile = object
  },
  [types.setResumableInfo] (state, data) {
    state.resumableInfo = data
  }
}

const actions = {
  setFileUploadDisplayAction ({commit}, boolean) {
    commit(types.setFileUploadDisplay, boolean)
  },
  setWaitUploadingAction ({commit}, data) {
    commit(types.setWaitUploading, data)
  },
  setCompleteFileAction ({commit}, object) {
    commit(types.setCompleteFile, object)
  },
  setResumableInfoAction ({commit}, data) {
    commit(types.setResumableInfo, data)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
